import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import apiClient from '../utils/apiClient';
import '../styles/AdminLogin.css';

const AdminForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);

    try {
      const response = await apiClient.post('/admin/request-recovery', { email });
      setSuccess(response.data.message);
      if (response.data.recoveryEmail) {
        setSuccess(`Recovery instructions sent to ${response.data.recoveryEmail}`);
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to send recovery email');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-container">
      <div className="admin-login-card">
        <div className="admin-login-header">
          <h2>Forgot Password</h2>
          <p>Enter your admin email to receive recovery instructions</p>
        </div>
        
        {error && <div className="error-banner">{error}</div>}
        {success && (
          <div style={{ 
            backgroundColor: '#e8f5e9', 
            color: '#2e7d32', 
            padding: '0.75rem', 
            borderRadius: '4px', 
            marginBottom: '1.5rem', 
            fontSize: '0.9rem', 
            textAlign: 'center',
            border: '1px solid #a5d6a7'
          }}>
            {success}
          </div>
        )}
        
        <form onSubmit={handleSubmit}>
          <div className="admin-form-group">
            <label>Admin Email Address</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@kalingastore.shop"
              required
              disabled={loading || success}
            />
          </div>
          
          <button type="submit" className="admin-login-btn" disabled={loading || success}>
            {loading ? 'Sending...' : 'Send Recovery Email'}
          </button>
        </form>
        
        <div style={{ marginTop: '1rem', textAlign: 'center' }}>
          <Link to="/admin/login" style={{ color: '#666', textDecoration: 'none', fontSize: '0.9rem' }}>
            ← Back to Login
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AdminForgotPassword;
